/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { IVisitor } from '../../visitors/IVisitor';

/**
 * Constructor.
 * @param {string} schemeName
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class SecurityScheme extends ExtensibleNode implements INamed {
    public _schemeName : string;

    public type : string;

    public description : string;

    public name : string;

    public in : string;

    public constructor(schemeName : string) {
        super();
        if(this._schemeName===undefined) this._schemeName = null;
        if(this.type===undefined) this.type = null;
        if(this.description===undefined) this.description = null;
        if(this.name===undefined) this.name = null;
        if(this.in===undefined) this.in = null;
        this._schemeName = schemeName;
    }

    /**
     * Gets the scheme name.
     * @return {string}
     */
    public getSchemeName() : string {
        return this._schemeName;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this.getSchemeName();
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._schemeName = newName;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitSecurityScheme(this);
    }
}
SecurityScheme["__class"] = "io.apicurio.datamodels.core.models.common.SecurityScheme";
SecurityScheme["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];





import { INamed } from './INamed';

